import React, { useState, useEffect } from "react";
import MyCircleList from "./my_circle_list";
import axios from "../axios";

const Profile = ({ userId, companyId, companyIdToParam }) => {
  // const [userfeeds, setUserFeeds] = useState([]);
  const [usersCircles, setUsersCircles] = useState([]);
  // const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  // const [isLastPage, setIsLastPage] = useState(false);
  // const [page, setPage] = useState(1);

  // スクロール時
  // const loadNextList = useCallback(
  //   () => {
  //     if (isLoadingNextList || isLastPage) {
  //       return;
  //     }
  //     setIsLoadingNextList(true);
  //     axios.get(`/api/userfeeds/users/${userId}?page=${page}`).then((res) => {
  //       setUserFeeds([...userfeeds, ...res.data.userfeeds]);
  //       setPage(page + 1);
  //       setIsLoadingNextList(false);
  //       setIsLastPage(res.data.isLastPage);
  //       if (res.data.userfeeds.length === 0) {
  //         setIsLastPage(true);
  //       }
  //     });
  //   },
  //   [isLoadingNextList, isLastPage, setIsLoadingNextList]
  // );

  useEffect(() => {
    // axios.get(`/api/userfeeds/users/${userId}?page=${page}`).then((res) => {
    //   setUserFeeds(res.data.userfeeds);
    // });
    if (companyId === undefined) {  // iconが渡されていない場合
      axios.get(`/api/member/profile/${userId}`).then((res) => {
        setUsersCircles(res.data.usersCircles);
      });
    } else {
      axios.get(`/api/member/profile/${userId}?company_id=${companyId}`).then((res) => {
        setUsersCircles(res.data.usersCircles);
      });
    }
  }, []);

  return (
    <React.Fragment>
      <div className="bg-white border-bottom">
        <div className="container col-md-8 col-lg-6">
          <ul
            className="list-unstyled d-flex scrollable-list mb-0"
            id="pills-tab2"
          >
            {/* <li className="col text-center show-tab-circle mypage2__event active">
              <a className="pt-3 d-block pb-2_5 nav-link--gray-soft active text-fz-12px" id="pills-circle-tab" data-toggle="pill" href="#pills-circle" aria-selected="true" role="tab" aria-controls="pills-circle">
                フィード
              </a>
            </li> */}
            <li className="col text-center show-tab-circle mypage2__event active">
              <a
                className="pt-3 pb-2_5 d-block nav-link--gray-soft text-fz-12px active"
              >
                参加サークル
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* <div className="tab-content" id="pills-tabContent--circle"> */}
        {/* <div className="tab-pane fade show active bg-white" id="pills-circle" role="tabpanel" aria-labelledby="pills-circle">
          { userfeeds.length ?
            <FeedList
            currentUser={currentUser}
            userfeeds={userfeeds}
            loadNextList={loadNextList}
            isLoadingNextList={isLoadingNextList}
            isLastPage={isLastPage}
            /> : ''}
          <div className="container col-md-8 col-lg-6">
            <h6 className="h6--list-title text-fz-14px text-black-50 pt-3">参加サークル
            </h6>
          </div>
          { usersCircles.length ?
            <MyCircleList
              usersCircles={usersCircles}
            /> : ''}
        </div> */}
      <div className="bg-white">
        {usersCircles.length ? (
          <MyCircleList 
            usersCircles={usersCircles}
            companyIdToParam={companyIdToParam}
          />
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};

export default Profile;
